import { render, staticRenderFns } from "./mobile-signature.vue?vue&type=template&id=0cebf2ba&scoped=true&"
import script from "./mobile-signature.vue?vue&type=script&lang=ts&"
export * from "./mobile-signature.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-signature.vue?vue&type=style&index=0&id=0cebf2ba&lang=less&scoped=true&"
import style1 from "./mobile-signature.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cebf2ba",
  null
  
)

export default component.exports